import cn from 'classnames';
import React, { type ReactNode } from 'react';
import { Text } from 'src/components/text/Text';

import { ReactComponent as Card } from './assets/card.svg';
import { ReactComponent as Navigation } from './assets/navigation.svg';
import { ReactComponent as Pie } from './assets/pie.svg';
import styles from './PayInFullItem.css';

interface Props {
  className?: string;
  title: string;
  description: string;
  iconType: 'card' | 'pie';
  selected: boolean;
  onToggle: () => void;
  children: ReactNode;
}

export const Item = ({
  className,
  title,
  description,
  iconType,
  selected,
  onToggle,
  children,
}: Props) => {
  return (
    <div className={cn(styles.PayInFullItem, className)}>
      <div className={styles.PayInFullItem__Toggle} onClick={onToggle}>
        <div className={styles.PayInFullItem__Icon}>
          {iconType === 'pie' && <Pie />}
          {iconType === 'card' && <Card />}
        </div>
        <div className={styles.PayInFullItem__Body}>
          <Text
            as="p"
            variant="body1TightBold"
            className={styles.PayInFullItem__Title}
          >
            {title}
          </Text>
          <Text
            as="p"
            variant="body2Tight"
            className={styles.PayInFullItem__Description}
          >
            {description}
          </Text>
        </div>
        <div
          className={cn(styles.PayInFullItem__Toggler, {
            [styles.PayInFullItem__Toggler_selected]: selected,
          })}
        >
          <Navigation />
        </div>
      </div>

      {selected && (
        <>
          <div className={styles.PayInFullItem__Divider} />
          <div className={styles.PayInFullItem__Extra}>{children}</div>
        </>
      )}
    </div>
  );
};
